<template>
  <div class="p-header-message">
    <div class="c-common-inner">
      <component
        :is="url === '' ? `p` : `a`"
        :href="url"
        class="p-header-message__body"
      >
        <span class="p-header-message__body__text">{{ message }}</span>
        <i v-if="url !== ''" class="p-header-message__body__arrow">
          <IconBase
            view-box="0 0 24 24"
            width="24"
            height="24"
            icon-color="#ffffff"
            class="p-group-list-panel__bottom__arrow"
          >
            <IconArrowRight />
          </IconBase>
        </i>
      </component>
    </div>
  </div>
</template>

<script lang="ts">
import { mapState } from "vuex";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowRight from "@/common/components/icons/IconArrowRight.vue";
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
	message: { type: String, required: false },
	url: { type: String, required: false }
  },
  components: {
    IconBase,
    IconArrowRight
  }
})
export default class HeaderMessage extends Vue {
  message!: string;
  url!: string;
}
</script>

<style lang="scss" scoped>
.p-header-message {
  @include pc {
    text-align: center;
  }
  background-color: #333;

  &__body {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: rem(12) 0;
    line-height: 1.6;

    &__text {
      @include pc {
        font-size: rem(14);
      }
      @include sp {
        font-size: rem(12);
      }
      color: #ffffff;
    }

    &__arrow {
      line-height: 0;
    }
  }
}
</style>
